<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = info.NickName)"></div>
    <img
      :src="
        info.AwardMemberModel
          ? 'https://files.alighting.com/cover/judges_top.png'
          : auditState == 1
          ? 'https://files.alighting.com/cover/business_top.png'
          : 'https://files.alighting.com/cover/personal_top.png'
      "
      class="topBg"
    />
    <!-- 查询转发 -->
    <div class="query-box">
      <router-link
        :to="{
          name: 'searchHomepage',
          query: {
            mid: mid,
            state: auditState,
            exhstate: exhibitionState,
            amid: info.AwardMemberModel.ID,
          },
        }"
        v-if="info.AwardMemberModel"
      >
        <div class="iconfont icon-search"></div>
      </router-link>
      <router-link
        :to="{
          name: 'searchHomepage',
          query: {
            mid: mid,
            state: auditState,
            exhstate: exhibitionState,
          },
        }"
        v-else
      >
        <div class="iconfont icon-search"></div>
      </router-link>
      <div class="iconfont icon-share1" @click.stop="shareHandle"></div>
    </div>

    <!-- 评委 -->
    <div v-if="info.AwardMemberModel">
      <div class="personal-box">
        <div class="avatarView">
          <van-image
            fit="contain"
            :src="info.Photo"
            round
            error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
          />
        </div>
        <div class="nameView">{{ info.NickName }}</div>
        <div class="p_number">
          <div>{{ info.TotalFans }}</div>
          粉丝
          <div class="right">{{ info.TotalFollows }}</div>
          关注
        </div>
        <div
          class="j_label"
          :style="{ marginTop: `${index == 0}?'10px':'5px'` }"
          v-for="(item, index) in info.AwardMemberModel.FieldList"
          :key="index"
        >
          <span class="iconfont icon-shenfen"></span
          >{{ info.AwardMemberModel.AwardYear }}阿拉丁神灯奖{{
            item.FieldId == 3 ? "（数智类）":(item.FieldId == 1 ? "（照明类）" : "（智能生态奖）")
          }}{{ item.IsFinalJury ? "终审委员" : item.JuryGroupDesc }}
        </div>
        <div class="operateBtn blue">
          <div
            @click.stop="followChange"
            :class="info.IsFollow ? '' : 'unfollow'"
          >
            <div v-if="info.IsFollow">
              <span
                class="iconfont icon-seleted"
                style="font-size: 12px; margin-right: 5px"
              ></span>
              已关注
            </div>
            <div v-else>
              <span
                class="iconfont icon-add"
                style="font-size: 11px; margin-right: 5px"
              ></span>
              关注
            </div>
          </div>
          <div @click.stop="chatHandle(info.NickName)">
            <span
              class="iconfont icon-liaotian"
              style="margin-right: 5px"
            ></span>
            聊一聊
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- 企业 -->
      <div v-if="auditState == 1">
        <div class="business-box">
          <div class="avatarView">
            <van-image
              fit="contain"
              :src="info.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
            <img
              src="../../../static/images/index/attestation.png"
              class="renzhengImg"
              v-if="exhibitionState == 1"
            />
            <img
              src="../../../static/images/index/attestation01.png"
              class="renzhengImg"
              v-else
            />
          </div>
          <div class="nameView">{{ info.NickName }}</div>
          <div class="synopsisView">
            {{ dealTextShow ? info.HeadlineIntroduction : dealText }}
            <div
              @click.stop="dealTextChange"
              v-if="
                info.HeadlineIntroduction != null &&
                info.HeadlineIntroduction.length > dealText.length
              "
            >
              <span
                class="iconfont"
                :class="dealTextShow ? 'icon-arrow-up' : 'icon-arrow-down'"
              ></span>
            </div>
          </div>
          <div class="b_number">
            <div>
              <div>{{ info.TotalReads }}</div>
              <div>总阅读量</div>
            </div>
            <div>
              <div>{{ info.TotalContents }}</div>
              <div>总内容量</div>
            </div>
            <div>
              <div>{{ info.TotalFans }}</div>
              <div>粉丝</div>
            </div>
            <div>
              <div>{{ info.TotalFollows }}</div>
              <div>关注</div>
            </div>
          </div>
          <div class="operateBtn">
            <div
              @click.stop="followChange"
              :class="info.IsFollow ? '' : 'unfollow'"
            >
              <div v-if="info.IsFollow">
                <span
                  class="iconfont icon-seleted"
                  style="font-size: 12px; margin-right: 5px"
                ></span>
                已关注
              </div>
              <div v-else>
                <span
                  class="iconfont icon-add"
                  style="font-size: 11px; margin-right: 5px"
                ></span>
                关注
              </div>
            </div>
            <div @click.stop="chatHandle(info.NickName)">
              <span
                class="iconfont icon-duihua"
                style="margin-right: 5px"
              ></span>
              聊一聊
            </div>
          </div>
        </div>
      </div>

      <!-- 个人 -->
      <div v-else>
        <div class="personal-box">
          <div class="avatarView">
            <van-image
              fit="contain"
              :src="info.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
          </div>
          <div class="nameView">{{ info.NickName }}</div>
          <div class="p_number">
            <div>{{ info.TotalFans }}</div>
            粉丝
            <div class="right">{{ info.TotalFollows }}</div>
            关注
          </div>
          <div class="synopsisView">这个家伙很懒，什么都没写....</div>
          <div class="operateBtn">
            <div
              @click.stop="followChange"
              :class="info.IsFollow ? '' : 'unfollow'"
            >
              <div v-if="info.IsFollow">
                <span
                  class="iconfont icon-seleted"
                  style="font-size: 12px; margin-right: 5px"
                ></span>
                已关注
              </div>
              <div v-else>
                <span
                  class="iconfont icon-add"
                  style="font-size: 11px; margin-right: 5px"
                ></span>
                关注
              </div>
            </div>
            <div @click.stop="chatHandle(info.NickName)">
              <span
                class="iconfont icon-liaotian"
                style="margin-right: 5px"
              ></span>
              聊一聊
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="type"
        :ellipsis="info.AwardMemberModel ? false : true"
        :color="info.AwardMemberModel ? '#3E69AF' : '#d62f2f'"
        :title-active-color="info.AwardMemberModel ? '#3E69AF' : '#d62f2f'"
        line-width="32px"
        line-height="5px"
        @change="typeChange"
        :swipeable="true"
        :swipe-threshold="5"
      >
        <van-tab title="动态">
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="getList"
          >
            <dynamic-list
              :list="list"
              :edit="edit"
              :homePage="false"
            ></dynamic-list>
          </van-list>
          <div class="noDataBox" v-if="list.length == 0">
            <span class="iconfont icon-kong"></span>
            <div>什么也没有！</div>
          </div>
        </van-tab>
        <van-tab title="话题">
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="getTopicList"
          >
            <div
              class="topicItemBox"
              v-for="(item, index) in list"
              :key="index"
            >
              <router-link
                :to="{ path: '/hotTopicDetails', query: { hid: item.TopicId } }"
              >
                <div class="topicItem">
                  <div class="ti_left">
                    <div class="tilTitle">#{{ item.TopicName }}#</div>
                    <div class="overFlowTwo">{{ item.TopicDesc }}</div>
                    <div class="times">
                      浏览次数：{{ item.Views }}次
                      <div>帖子数：{{ item.PostCount }}条</div>
                    </div>
                  </div>
                  <img :src="item.BackImage" class="tiImg" />
                </div>
              </router-link></div
          ></van-list>
          <div class="noDataBox" v-if="list.length == 0">
            <span class="iconfont icon-kong"></span>
            <div>什么也没有！</div>
          </div>
        </van-tab>
        <div v-if="auditState == 1">
          <van-tab title="文章">
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getArticleList"
            >
              <div class="commonBox" v-for="(item, index) in list" :key="index">
                <!-- 样式一 -->
                <div
                  class="common classThree"
                  v-if="item.CoverNum == 1"
                  @click="toArticleDetail(item.ContentID)"
                >
                  <div class="classTitle">
                    {{ item.Title }}
                  </div>
                  <img class="imgItemThree" :src="item.Thumbnail" />
                </div>
                <!-- 样式二 -->
                <div
                  class="common"
                  v-if="item.CoverNum == 3"
                  @click="toArticleDetail(item.ContentID)"
                >
                  <div class="classTitle title">{{ item.Title }}</div>
                  <div class="imgBox">
                    <img
                      class="imgItem"
                      v-for="(inner, innerIndex) in item.ThumbnailList"
                      :key="innerIndex"
                      :src="inner"
                    />
                  </div>
                </div>
                <!-- 样式三 -->
                <div
                  class="common"
                  v-if="item.CoverNum == 0"
                  @click="toArticleDetail(item.ContentID)"
                >
                  <div class="classTitle title">{{ item.Title }}</div>
                </div>
              </div>
            </van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <span class="iconfont icon-kong"></span>
              <div>什么也没有！</div>
            </div>
          </van-tab>
          <van-tab title="视频">
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getVideoList"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  padding: 10px 15px;
                  background: #ffffff;
                "
              >
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  @click="toVideoDetail(item.VodId)"
                >
                  <div class="videoItem">
                    <div class="v_top">
                      <van-image
                        fit="cover"
                        :src="item.CoverUrl"
                        class="vImg"
                      />
                      <img
                        src="../../../static/images/index/play.png"
                        class="playIcon"
                      />
                    </div>
                    <div class="v_btm overFlowTwo">{{ item.Title }}</div>
                  </div>
                </div>
              </div>
            </van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <span class="iconfont icon-kong"></span>
              <div>什么也没有！</div>
            </div></van-tab
          >
          <div v-if="exhibitionState == 1 || isInter == 1">
            <van-tab title="展厅"></van-tab>
          </div>
        </div>
        <div v-if="info.AwardMemberModel">
          <van-tab title="相关简介">
            <div
              class="noDataBox"
              v-if="
                !info.AwardMemberModel.CompanyName &&
                !info.AwardMemberModel.Title &&
                !info.AwardMemberModel.Introduction &&
                !info.AwardMemberModel.CompanyIntroduction
              "
            >
              <div class="kongIcon">
                <span class="iconfont icon-kong"></span>
              </div>
              <div>什么也没有！</div>
            </div>
            <div class="profile-box" v-else>
              <div v-if="info.AwardMemberModel.CompanyName">
                <div class="pb_bold">单位名称：</div>
                <div>
                  <span>{{ info.AwardMemberModel.CompanyName }}</span>
                </div>
              </div>
              <div v-if="info.AwardMemberModel.Title">
                <div class="pb_bold">职务职称：</div>
                <div>
                  <span>{{ info.AwardMemberModel.Title }}</span>
                </div>
              </div>
              <div v-if="info.AwardMemberModel.Introduction">
                <div class="pb_bold">个人简介：</div>
                <div
                  class="wxParse"
                  v-html="info.AwardMemberModel.Introduction"
                ></div>
              </div>
              <div v-if="info.AwardMemberModel.CompanyIntroduction">
                <div class="pb_bold">企业简介：</div>
                <div
                  class="wxParse"
                  v-html="info.AwardMemberModel.CompanyIntroduction"
                ></div>
              </div>
            </div>
          </van-tab>
          <van-tab title="TA的推荐">
            <div class="recTips" v-if="total">共有{{ total }}个推荐</div>
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getTaList"
            >
              <div
                class="recItem"
                v-for="(item, index) in list"
                :key="index"
                @click.stop="toPathHandle(item.ID)"
              >
                <div class="overFlowOne">{{ item.Subject }}</div>
                <div>
                  <span>{{ item.AddTime }}</span
                  ><span>{{ item.Click }}浏览</span>
                </div>
              </div>
            </van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <div class="kongIcon">
                <span class="iconfont icon-kong"></span>
              </div>
              <div>什么也没有！</div>
            </div>
          </van-tab>
        </div>
      </van-tabs>
    </div>

    <!-- 右侧按钮 -->
    <div class="right-box">
      <div @click.stop="toShenBao">
        <img src="../../../static/images/lighting/declare.png" />
      </div>
    </div>
    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { videoList } from "@/api/video";
import { articleList } from "@/api/article";
import { juryCommendArticleList } from "@/api/lighting";
import DynamicList from "@/components/dynamicList";
import {getShareData } from "@/utils/share";
import { Col, Icon, List, Overlay, Row, Tab, Tabs, Toast, Image } from "vant";
import { memberInfo, memberPostList, memberTopicList } from "@/api/homepage";
import { followMember, unFollowMember } from "@/api/index";
import { formatTimeDay } from "@/utils/date";

export default {
  name: "homePage",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-icon": Icon,
    "van-row": Row,
    "van-col": Col,
    "van-overlay": Overlay,
    "van-image": Image,
    Toast,
    DynamicList,
  },
  data() {
    return {
      type: 0, //1动态 2话题 3文章 4视频 5展厅
      tabTitle: "动态",
      auditState: 0, //0普通会员 1认证会员 (头条号状态)
      exhibitionState: 0, //展厅状态-中文  1高级会员
      isInter: 0, //展厅状态-英文
      
      info: "",

      //处理简介
      dealText: "",
      dealTextShow: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      edit: false, //数据可操作（本人，可删除数据）

      interDomain: "", //域名
      showLayer: false,

      mid: null,
    };
  },
  methods: {
    //申报
    toShenBao() {
      window.location.href =
        "https://www.alighting.cn/webapp/award/declare.htm?t=1";
    },

    //聊一聊
    chatHandle(name) {
      Toast("暂无该功能！");
      // if (this.edit) {
      //   Toast("不能和自己聊天哦");
      //   return false;
      // }
      // this.$router.push({
      //   path: "/chat",
      //   query: { cid: "C2C" + this.$route.query.mid, name: name },
      // });
    },

    //企业简介显示全部切换
    dealTextChange() {
      this.dealTextShow = !this.dealTextShow;
    },

    //分享好友
    shareHandle() {
      this.showLayer = true;
    },

    //获取会员状态
    getStatus(tab) {
      var that = this;
      var data = {
        MemberId: that.mid,
      };
      memberInfo(data).then((res) => {
        if (localStorage.getItem("token")) {
          that.edit = res.MemberID == that.mid ? true : false;
        } else {
          that.edit = false;
        }

        let dealText = "";
        if (res.Data.HeadlineIntroduction) {
          dealText = that.Common.getStr(res.Data.HeadlineIntroduction, 138);
        }

        var type = 0,
          tabTitle = "动态";
        if (tab) {
          //转发打开
          type = Number(tab);
          if (type == 1) {
            tabTitle = "话题";
          } else if (type == 2) {
            tabTitle =
              res.Data.AuditState == 1
                ? "文章"
                : res.Data.AwardMemberModel
                ? "相关简介"
                : "";
          } else if (type == 3) {
            tabTitle =
              res.Data.AuditState == 1
                ? "视频"
                : res.Data.AwardMemberModel
                ? "TA的推荐"
                : "";
          } else if (type == 4) {
            tabTitle =
              res.Data.ExhibitionState == 1 || res.Data.IsInter == 1
                ? "展厅"
                : "相关简介";
          } else if (type == 5) {
            tabTitle =
              res.Data.ExhibitionState == 1 || res.Data.IsInter == 1
                ? "相关简介"
                : "TA的推荐";
          } else if (type == 6) {
            tabTitle = "TA的推荐";
          } else {
          }
        } else if (res.Data.AwardMemberModel) {
          type =
            res.Data.AuditState == 1
              ? res.Data.ExhibitionState == 1 || res.Data.IsInter == 1
                ? 5
                : 4
              : 2;
          tabTitle = "相关简介";
        } else {
        }

        that.type = type;
        that.tabTitle = tabTitle;
        that.info = res.Data;
        that.dealText = dealText;
        that.auditState = res.Data.AuditState;
        that.exhibitionState = res.Data.ExhibitionState;
        that.isInter = res.Data.IsInter;
        that.interDomain = res.Data.InterDomain;

        getShareData(
          window.location.href,
          res.Data.NickName + "的个人主页，快来看看呀",
          that.Common.ToText(that.dealText).substr(0, 50)
            ? that.Common.ToText(that.dealText).substr(0, 50)
            : "",
          res.Data.Photo
        );
      });
    },

    //关注操作
    followChange() {
      if (this.info.IsFollow) {
        unFollowMember({ MemberId: this.mid }).then((res) => {
          Toast("取消关注");
          this.info.IsFollow = false;
        });
      } else {
        followMember({ MemberId: this.mid }).then((res) => {
          Toast("关注成功");
          this.info.IsFollow = true;
        });
      }
    },

    //跳转视频详情
    toVideoDetail(id) {
      this.$router.push({
        path: "/videoDetail",
        query: { id: id },
      });
    },

    //跳转文章详情
    toArticleDetail(id) {
      this.$router.push({
        path: "/articleDetail",
        query: { id: id },
      });
    },

    //跳转推荐详情
    toPathHandle(id) {
      this.$router.push({
        path: "/recDetail",
        query: {
          id: id,
        },
      });
    },

    //tab切换
    typeChange(name, title) {
      this.type = name;
      this.tabTitle = title;
      this.pageIndex = 1;
      this.list = [];
      if (this.tabTitle == "展厅") {
        if (this.exhibitionState == 1) {
          this.$router.push({
            path: "/storeShow",
            query: { mid: this.mid },
          });
        } else {
          window.location.href =
            "https://m.lightstrade.com/storeShow/" + this.interDomain;
        }
      } else if (this.tabTitle == "相关简介") {
        return false;
      } else if (this.tabTitle == "动态") {
        this.getList();
      } else if (this.tabTitle == "话题") {
        this.getTopicList();
      } else if (this.tabTitle == "文章") {
        this.getArticleList();
      } else if (this.tabTitle == "视频") {
        this.getVideoList();
      } else if (this.tabTitle == "TA的推荐") {
        this.getTaList();
      }else{}
    },

    //动态
    getList() {
      var that = this;
      var data = {
        MemberId: that.mid,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      memberPostList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //话题
    getTopicList() {
      var that = this;
      var data = {
        MemberId: that.mid,
        Type: 0,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      memberTopicList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          // 加载状态结束
          that.loading = false;
          // 数据全部加载完成
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //文章
    getArticleList() {
      var that = this;
      var data = {
        MemberId: that.mid,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      articleList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //视频
    getVideoList() {
      var that = this;
      var data = {
        Keyword: "",
        Page: {
          PageSize: 16,
          PageIndex: that.pageIndex,
        },
        MemberId: that.mid,
      };
      videoList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //TA的推荐
    getTaList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
        AwardYear: that.awardYear,
        AwardMemebrId: that.info.AwardMemberModel.ID,
      };
      juryCommendArticleList(data)
        .then((res) => {
          var list = res.Data.List;
          list.forEach((item, index) => {
            item.AddTime = formatTimeDay(item.AddTime, "-");
          });
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },
  },

  mounted() {
    this.mid = this.$route.query.mid;
    this.getStatus();
  },
};
</script>
<style scoped src="../../../static/css/homepage.css"></style>
